export default __webpack_public_path__ + "static/media/inGame.d9e51f03.png";